import axios from '../../../configs/axios';

export default {
  fetchCustomExports(filters, searchParams = '') {
    return axios.get(`/custom_exports.json${searchParams}`, {
      params: {
        request: {
          assets: {
            reports: {
              filters,
            },
          },
        },
      },
    });
  },
  updateCustomExport(id, updatedData) {
    return axios.put(`/custom_exports/${id}`, updatedData);
  },
  updateCustomExports(exportsData) {
    return axios.post('/custom_exports/update_many', exportsData);
  },
  downloadCustomExports(exportsData) {
    return axios.post('/custom_exports/download_many', exportsData);
  },
  deleteCustomExport(id) {
    return axios.delete(`/custom_exports/${id}`, { data: { id } });
  },
  updatePerPage(perPage) {
    return axios.post('/profile/update_options', { page_name: 'custom_exports', options: { per_page: perPage } });
  },
};
